/* jshint esversion: 6 */

import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next';
import BootstrapVue from 'bootstrap-vue';
import ValidationErrorHandling from './src/Vue/Directives/ValidationErrorHandling';

Vue.use(BootstrapVue);
Vue.use(VueI18Next);

// Polyfills
require('babel-polyfill');
require('./src/polyfills/object');
require('./src/polyfills/array');


window.jQuery = window.$ = require('jquery');
window.moment = require('moment');
window.axios = require('axios');

//locale
let lang = window.env.language || 'en';
window.moment.locale(lang);
window.i18n = window.i18next =  i18next;
i18next.init({
    lng: lang,
    fallbackLng: 'en',
    whitelist: ['en', 'fr'],
    ns: 'default',
    defaultNS: 'default',
    resources: {
        en: require('./locales/en/default'),
        fr: require('./locales/fr/default')
    }
});

window.datatableLanguage = require(`./locales/${lang}/datatables`).default;


// Include code for jquery-based views
require('./include/_utils');
require('./include/_jquery_ui');
require('./include/_jquery_cookie');
require('./include/_jquery_mask');
require('./include/_jquery_serializeobject');
require('./include/_jquery_tooltipster_min');
require('./include/_jquery_tablesorter');
require('./include/_general');
require('./include/_modal_save_quote');
require('./include/_calendar');
require('./include/_fares_filter');
require('./include/_progress_bar');
require('./include/_flightsearch_form');
require('./include/_matrix');
require('./include/_lion_sort');
require('./include/_bootstrap.typeahead');
require('./include/_airport_typeahead');
require('./include/_combodate');
require('./include/cars/_search_form');
require('./include/cars/_booking_detail');

// Configure Vue

window.Vue = Vue;

const i18n = new VueI18Next(i18next);
Vue.mixin({
    i18n,
    computed: {
        window() {
            return window;
        },
        isInternal() {
            return !!window.env.internal;
        }
    }
});
Vue.directive('validate', ValidationErrorHandling);

require('./src/Vue/filters');
require('./src/Vue/methods');

// Include Root Vue.js Components for Vue based view
import CarsSearchResult from './src/Vue/Components/Cars/Search/Search';
import CarsCheckoutForm from './src/Vue/Components/Cars/Checkout/Form';
import NewAgentList from './src/Vue/Components/Agent/NewAgentList.vue';
import SurveyCsatComponent from './src/Vue/Components/Surveys/Csat.vue';
import SurveyQuestionnaireComponent from './src/Vue/Components/Surveys/Questioinnaire';

Vue.component('cars-search-results', CarsSearchResult);
Vue.component('cars-checkout-form', CarsCheckoutForm);
Vue.component('new-agent-list', NewAgentList);
Vue.component('survey-csat-view', SurveyCsatComponent);
Vue.component('survey-questionnaire-view', SurveyQuestionnaireComponent);
